import React, { createContext, useContext, useState, useCallback } from "react";

const STR = {
  en: {
    app_name: "PM POSHAN MDM Calculator",
    tagline: "Daily Mid Day Meal cooking cost & rice calculator for Odisha schools",
    home: "Home", entry: "Entry", reports: "Reports", profile: "Profile", history: "History",
    dashboard: "Dashboard", articles: "Articles", guide: "Guide", about: "About", contact: "Contact",
    login: "Login", register: "Register", logout: "Logout", get_started: "Get Started",
    mobile: "Mobile Number", password: "Password", confirm_password: "Confirm Password",
    full_name: "Full Name", remember_me: "Remember me", forgot_password: "Forgot password?",
    daily_entry: "Daily Entry", mdm_calc: "MDM Calculation", rice_calc: "Rice Calculation",
    cooking_cost: "Cooking Cost", daily_report: "Daily Report", weekly_report: "Weekly Report",
    monthly_report: "Monthly Report (MDCF)", annual_report: "Annual Report", uc_report: "UC Report",
    mdcf_form: "MDCF Form",
    calculate: "Calculate", save_entry: "Save Entry", total_present: "Total Present",
    date: "Date", day: "Day", students: "Students", total_cost: "Total Cost", avg_student: "Avg / Student",
    rice_kg: "Rice (kg)", grand_total: "Grand Total", per_student: "Per Student", rate: "Rate",
    total_qty: "Total Qty", amount: "Amount", item: "Item", menu_today: "Today's Menu",
    ingredients_summary: "Ingredients Summary (All Categories)",
    export_pdf: "PDF", export_excel: "Excel", share_whatsapp: "WhatsApp",
    my_calculators: "My Calculators",
    balvatika: "Balvatika", primary: "Primary (I–V)", upper_primary: "Upper Primary (VI–VIII)", high_school: "High School (IX–X)",
    school_name: "School Name", udise: "UDISE Code", block: "Block", district: "District", hm_name: "Headmaster Name",
    enrolled: "Enrolled Students", save: "Save", cancel: "Cancel", change_password: "Change Password",
    admin: "Admin", users: "Users", rates: "Rates", menus: "Menus", content: "Content",
    view: "View", download: "Download", laddoo_day: "Laddoo Day", auto: "Auto",
    lang_label: "ଓଡ଼ିଆ", welcome: "Welcome", today_entry: "Today's Entry",
    this_month: "This Month", days_entered: "Days Entered", last7: "Last 7 Days",
    pricing: "Pricing", my_plan: "My Plan", annual_plan: "Annual Plan", year: "year",
    upgrade_title: "Upgrade to continue", upgrade_sub: "This feature needs an active subscription.",
    free_calcs_left: "free calculations left", free_calcs: "free calculations",
    last_free_calc: "Last free calculation!", used_all_pre: "You've used all",
    trial_reminder_pre: "Only", trial_reminder_post: "free calculations left. Get unlimited access for just ₹99/year.",
    upgrade_trial_sub: "Continue with unlimited calculations, saving and all reports for ₹99/year.",
    refer_get_free: "Refer 100 teachers → 1 year FREE + free recharge",
    dry_ration_report: "Dry Ration", working_days: "Working Days",
    dry_ration_amount: "Dry Ration", total_payout: "Total Payout",
    pw_ready_title: "Your report for {date} is ready!",
    pw_ready_sub: "{students} students · {classes} classes · all totals calculated, just unlock to see them.",
    pw_perk1: "Unlimited daily calculations",
    pw_perk2: "Save every entry and history calendar",
    pw_perk3: "Monthly MDCF (2 pages), Annual & UC reports",
    pw_perk4: "PDF, Excel and WhatsApp sharing",
    pw_perk5: "Dry ration and holiday tracking",
    pw_unlock_btn: "Unlock My Report — Pay ₹{price}",
    pw_joined: "Joined by {n} teachers 👩‍🏫",
    pw_this_week: "{n} teachers subscribed this week",
    pw_refund: "7-day refund policy", pw_secure: "Secure payment",
    pw_refer_alt: "🎁 Or refer 100 teachers → 1 year FREE + free recharge →",
    pw_maybe_later: "Maybe later",
    pw_unlocked: "Unlocked! Unlimited access till {date}",
    incl_taxes: "Inclusive of all taxes", processing: "Processing…", pay: "Pay",
    register_to_subscribe: "Register to subscribe", secure_razorpay: "Secure payment via Razorpay",
    renew: "Renew", subscribe_now: "Subscribe now", whats_included: "What's included",
    payment_history: "Payment History", download_receipt: "Receipt", start_date: "Start date",
    expiry_date: "Expiry date", days_left: "days left", status: "Status",
    plan_active: "Active", plan_expired: "Expired", plan_none: "Not subscribed",
    subscriptions: "Subscriptions", payments: "Payments", settings: "Settings",
    refer_earn: "Refer & Earn", refer_headline: "Refer 100 teachers → Get DOUBLE REWARD! 🎉",
    refer_sub: "Just share your link in your teacher WhatsApp groups.",
    reward1_title: "1 YEAR FREE", reward1_desc: "Worth ₹99 · unlimited calculations & all reports",
    reward2_title: "3 MONTHS UNLIMITED RECHARGE", reward2_desc: "Calls + data on your own number",
    total_value_up_to: "Total value up to", tnc_apply: "T&C apply",
    claim_recharge: "Claim your recharge", recharge_reward: "3-Month Recharge Reward",
    my_number: "Your registered number", operator: "Operator", circle: "Circle",
    confirm_own_number: "This is my own active prepaid number", claim_now: "Claim now",
    prepaid_only: "Recharge is for prepaid numbers only. If postpaid, the admin may offer extra free subscription months instead.",
    st_claimed: "Claimed", st_verification: "Under verification", st_approved: "Approved",
    st_done: "Recharge done", st_rejected: "Rejected",
    only_x_more_double: "more for your FREE year + FREE recharge!",
    qr_or_scan: "Or pay by scanning UPI QR (GPay, PhonePe, Paytm, BHIM)",
    qr_pay_title: "Pay by UPI QR", qr_scan_pay: "Scan & Pay", qr_pay_exact: "Pay exactly",
    qr_download: "Download QR", qr_step1: "Open any UPI app", qr_step2: "Scan or upload this QR",
    qr_step3: "Pay ₹99 & note the UTR / Transaction ID",
    qr_warn: "Pay the exact amount. Wrong amounts may delay activation.",
    qr_proof_title: "Submit payment proof", qr_utr: "UTR / UPI Transaction ID (12 digits)",
    qr_amount: "Amount paid", qr_datetime: "Payment date & time", qr_app: "UPI app used",
    qr_screenshot: "Payment screenshot (JPG/PNG, max 3 MB)", qr_submit: "Submit for verification",
    qr_send_admin: "Send proof to Admin on WhatsApp",
    qr_attach_note: "Please attach your payment screenshot in WhatsApp too.",
    qr_pending_status: "QR payment under verification (usually within a few hours)",
    qr_resubmit: "Resubmit", qr_request_id: "Request ID",
    copy_code: "Copy code", copied: "Copied", more_to_go: "more to go!",
    share_now: "Share now", how_it_works: "How it works", my_referrals: "My Referrals",
    download_poster: "Download poster", refer_terms: "Referral Program Terms",
    all: "All", valid: "Valid", pending: "Pending",
    working_day: "Working Day", holiday: "Holiday", mdm_serving: "MDM Serving Day",
    dry_ration_day: "Dry Ration Day", todays_meal: "Today's Meal", mark_holiday: "Mark as Holiday",
    holiday_reason: "Holiday reason", editing_saved: "Editing saved entry",
    students_dry: "Students receiving dry ration", payment_mode: "Payment mode",
    bank_dbt: "Bank Account (DBT)", cash_hand: "Cash in Hand", laddoo_day: "Laddoo Day", egg_day: "Egg Day",
    day_type_req: "Please choose a day type first.", future_preview: "Future date — preview only, cannot save.",
    download_pdf: "Download PDF", download_excel: "Download Excel", replace_saved: "Replace saved entry?",
    govt_holiday: "Government Holiday", not_for_entry: "Not for Entry",
    bulk_entry: "Bulk Entry", bulk: "Bulk", more: "More", language: "Language", suggestions: "Suggestions",
    bulk_choose_period: "Choose the period", bulk_month_mode: "Month", bulk_range_mode: "Custom range",
    bulk_from: "From", bulk_to: "To", bulk_range_max: "Range can be at most 31 days.",
    bulk_calc_preview: "Calculate & Preview", bulk_save_all: "Save All", bulk_back_edit: "Back to edit",
    bulk_ready: "ready", bulk_missing: "missing", bulk_holidays: "holidays",
    bulk_copy_prev: "Copy previous day", bulk_fill_working: "Fill all working days with",
    bulk_use_enrolled: "Use enrolled numbers", bulk_mark_sundays: "Mark all Sundays as Holiday",
    bulk_apply: "Apply", bulk_saved_chip: "Saved", bulk_will_update: "Will update",
    bulk_speed_tools: "Speed tools", bulk_filter: "Filter",
    bulk_upgrade_title: "Save a whole month in 2 minutes with Bulk Entry — ₹99/year",
    bulk_download_template: "Download template", bulk_upload_excel: "Upload filled Excel",
    bulk_preview_title: "Preview & Save", bulk_month_totals: "Month totals",
    bulk_mdm_days: "MDM days", bulk_dry_days: "Dry ration days",
    bulk_total_cooking: "Total cooking cost", bulk_dry_amount: "Dry ration amount",
    bulk_total_rice: "Total rice", bulk_fix: "Fix", bulk_errors_top: "Fix these first",
    bulk_saving: "Saving…", bulk_saved_result: "days saved", bulk_skipped_result: "skipped",
    bulk_update_confirm: "already-saved days will be updated. Continue?",
    bulk_update_btn: "Update", bulk_skip_btn: "Skip changed",
    bulk_view_mdcf: "View Monthly (MDCF)", bulk_demo_note: "This is a preview. Subscribe to save a whole month at once.",
    bulk_students: "Students by class", status_dot: "Status",
    preparing_receipt: "Preparing…", share_receipt: "Share receipt",
    msg_preview: "Message preview", share_whatsapp: "Share on WhatsApp",
    copy_message: "Copy message", copy_short: "Copy short message", msg_copied: "Message copied!",
    unsaved_download_hint: "Unsaved changes — we'll save the latest, then download",
    save_download_pdf: "Save & PDF", save_download_excel: "Save & Excel",
  },
  or: {
    app_name: "PM POSHAN MDM ଗଣନା",
    tagline: "ଓଡ଼ିଶା ବିଦ୍ୟାଳୟ ପାଇଁ ଦୈନିକ ମଧ୍ୟାହ୍ନ ଭୋଜନ ରୋଷେଇ ଖର୍ଚ୍ଚ ଓ ଚାଉଳ ହିସାବ",
    home: "ମୂଳପୃଷ୍ଠା", entry: "ଏଣ୍ଟ୍ରି", reports: "ରିପୋର୍ଟ", profile: "ପ୍ରୋଫାଇଲ୍", history: "ଇତିହାସ",
    dashboard: "ଡ୍ୟାସବୋର୍ଡ", articles: "ପ୍ରବନ୍ଧ", guide: "ମାର୍ଗଦର୍ଶିକା", about: "ଆମ ବିଷୟରେ", contact: "ଯୋଗାଯୋଗ",
    login: "ଲଗଇନ୍", register: "ପଞ୍ଜୀକରଣ", logout: "ଲଗଆଉଟ୍", get_started: "ଆରମ୍ଭ କରନ୍ତୁ",
    mobile: "ମୋବାଇଲ୍ ନମ୍ବର", password: "ପାସୱାର୍ଡ", confirm_password: "ପାସୱାର୍ଡ ନିଶ୍ଚିତ କରନ୍ତୁ",
    full_name: "ପୂରା ନାମ", remember_me: "ମୋତେ ମନେ ରଖନ୍ତୁ", forgot_password: "ପାସୱାର୍ଡ ଭୁଲିଗଲେ?",
    daily_entry: "ଦୈନିକ ଏଣ୍ଟ୍ରି", mdm_calc: "MDM ଗଣନା ହିସାବ", rice_calc: "ଚାଉଳ ହିସାବ",
    cooking_cost: "ରୋଷେଇ ଖର୍ଚ୍ଚ ହିସାବ", daily_report: "ଦୈନିକ ରିପୋର୍ଟ", weekly_report: "ସାପ୍ତାହିକ ରିପୋର୍ଟ",
    monthly_report: "ମାସିକ ରିପୋର୍ଟ (MDCF)", annual_report: "ବାର୍ଷିକ ରିପୋର୍ଟ", uc_report: "UC ରିପୋର୍ଟ",
    mdcf_form: "MDCF ଫର୍ମ",
    calculate: "ଗଣନା କରନ୍ତୁ", save_entry: "ଏଣ୍ଟ୍ରି ସେଭ୍ କରନ୍ତୁ", total_present: "ମୋଟ ଉପସ୍ଥିତ",
    date: "ତାରିଖ", day: "ବାର", students: "ଛାତ୍ର", total_cost: "ମୋଟ ଖର୍ଚ୍ଚ", avg_student: "ହାରାହାରି / ଛାତ୍ର",
    rice_kg: "ଚାଉଳ (କି.ଗ୍ରା)", grand_total: "ମୋଟ ଯୋଗଫଳ", per_student: "ପ୍ରତି ଛାତ୍ର", rate: "ଦର",
    total_qty: "ମୋଟ ପରିମାଣ", amount: "ରାଶି", item: "ସାମଗ୍ରୀ", menu_today: "ଆଜିର ମେନୁ",
    ingredients_summary: "ସାମଗ୍ରୀ ସାରାଂଶ (ସମସ୍ତ ବର୍ଗ)",
    export_pdf: "PDF", export_excel: "Excel", share_whatsapp: "WhatsApp",
    my_calculators: "ମୋ କ୍ୟାଲକୁଲେଟର",
    balvatika: "ବାଲ୍‌ଵାଟିକା", primary: "ପ୍ରାଥମିକ (I–V)", upper_primary: "ଉଚ୍ଚ ପ୍ରାଥମିକ (VI–VIII)", high_school: "ଉଚ୍ଚ ବିଦ୍ୟାଳୟ (IX–X)",
    school_name: "ବିଦ୍ୟାଳୟ ନାମ", udise: "UDISE କୋଡ୍", block: "ବ୍ଲକ୍", district: "ଜିଲ୍ଲା", hm_name: "ପ୍ରଧାନ ଶିକ୍ଷକ ନାମ",
    enrolled: "ନାମଲେଖା ଛାତ୍ର", save: "ସେଭ୍", cancel: "ବାତିଲ୍", change_password: "ପାସୱାର୍ଡ ବଦଳାନ୍ତୁ",
    admin: "ଆଡମିନ୍", users: "ଉପଯୋଗକର୍ତ୍ତା", rates: "ଦର", menus: "ମେନୁ", content: "ବିଷୟବସ୍ତୁ",
    view: "ଦେଖନ୍ତୁ", download: "ଡାଉନଲୋଡ୍", laddoo_day: "ଲଡ୍ଡୁ ଦିନ", auto: "ଅଟୋ",
    lang_label: "English", welcome: "ସ୍ୱାଗତ", today_entry: "ଆଜିର ଏଣ୍ଟ୍ରି",
    this_month: "ଏହି ମାସ", days_entered: "ଏଣ୍ଟ୍ରି ଦିନ", last7: "ଗତ ୭ ଦିନ",
    pricing: "ମୂଲ୍ୟ", my_plan: "ମୋ ପ୍ଲାନ୍", annual_plan: "ବାର୍ଷିକ ପ୍ଲାନ୍", year: "ବର୍ଷ",
    upgrade_title: "ଆଗକୁ ବଢ଼ିବାକୁ ଅପଗ୍ରେଡ୍ କରନ୍ତୁ", upgrade_sub: "ଏହି ସୁବିଧା ପାଇଁ ଏକ ସକ୍ରିୟ ସବସ୍କ୍ରିପସନ୍ ଆବଶ୍ୟକ।",
    free_calcs_left: "ମାଗଣା ଗଣନା ବାକି", free_calcs: "ମାଗଣା ଗଣନା",
    last_free_calc: "ଶେଷ ମାଗଣା ଗଣନା!", used_all_pre: "ଆପଣ ସମସ୍ତ",
    trial_reminder_pre: "ମାତ୍ର", trial_reminder_post: "ମାଗଣା ଗଣନା ବାକି। ମାତ୍ର ₹99/ବର୍ଷରେ ଅସୀମିତ ଆକ୍ସେସ୍ ପାଆନ୍ତୁ।",
    upgrade_trial_sub: "ଅସୀମିତ ଗଣନା, ସେଭ୍ ଓ ସମସ୍ତ ରିପୋର୍ଟ ପାଇଁ ₹99/ବର୍ଷ।",
    refer_get_free: "100 ଶିକ୍ଷକ ରେଫର୍ → 1 ବର୍ଷ ମାଗଣା + ମାଗଣା ରିଚାର୍ଜ",
    dry_ration_report: "ଶୁଖିଲା ରାସନ", working_days: "କାର୍ଯ୍ୟ ଦିନ",
    dry_ration_amount: "ଶୁଖିଲା ରାସନ", total_payout: "ମୋଟ ଦେୟ",
    pw_ready_title: "{date} ର ଆପଣଙ୍କ ରିପୋର୍ଟ ପ୍ରସ୍ତୁତ!",
    pw_ready_sub: "{students} ଛାତ୍ର · {classes} ଶ୍ରେଣୀ · ସମସ୍ତ ହିସାବ ହୋଇଛି, କେବଳ ଖୋଲନ୍ତୁ।",
    pw_perk1: "ଅସୀମିତ ଦୈନିକ ଗଣନା",
    pw_perk2: "ପ୍ରତ୍ୟେକ ଏଣ୍ଟ୍ରି ଓ ହିଷ୍ଟ୍ରି କ୍ୟାଲେଣ୍ଡର ସେଭ୍",
    pw_perk3: "ମାସିକ MDCF (2 ପୃଷ୍ଠା), ବାର୍ଷିକ ଓ UC ରିପୋର୍ଟ",
    pw_perk4: "PDF, Excel ଓ WhatsApp ସେୟାର୍",
    pw_perk5: "ଶୁଖିଲା ରାସନ ଓ ଛୁଟି ଟ୍ରାକିଂ",
    pw_unlock_btn: "ମୋ ରିପୋର୍ଟ ଖୋଲନ୍ତୁ — ₹{price} ଦିଅନ୍ତୁ",
    pw_joined: "{n} ଶିକ୍ଷକ ଯୋଗ ଦେଇଛନ୍ତି 👩‍🏫",
    pw_this_week: "ଏହି ସପ୍ତାହରେ {n} ଶିକ୍ଷକ ସବସ୍କ୍ରାଇବ୍ କଲେ",
    pw_refund: "୭-ଦିନ ରିଫଣ୍ଡ ନୀତି", pw_secure: "ସୁରକ୍ଷିତ ପେମେଣ୍ଟ",
    pw_refer_alt: "🎁 କିମ୍ବା 100 ଶିକ୍ଷକ ରେଫର୍ → 1 ବର୍ଷ ମାଗଣା + ମାଗଣା ରିଚାର୍ଜ →",
    pw_maybe_later: "ପରେ କରିବି",
    pw_unlocked: "ଖୋଲିଗଲା! {date} ପର୍ଯ୍ୟନ୍ତ ଅସୀମିତ ଆକ୍ସେସ୍",
    incl_taxes: "ସମସ୍ତ କର ଅନ୍ତର୍ଭୁକ୍ତ", processing: "ପ୍ରକ୍ରିୟାକରଣ…", pay: "ଦେୟ",
    register_to_subscribe: "ସବସ୍କ୍ରାଇବ୍ କରିବାକୁ ପଞ୍ଜୀକରଣ କରନ୍ତୁ", secure_razorpay: "Razorpay ମାଧ୍ୟମରେ ସୁରକ୍ଷିତ ଦେୟ",
    renew: "ନବୀକରଣ", subscribe_now: "ବର୍ତ୍ତମାନ ସବସ୍କ୍ରାଇବ୍ କରନ୍ତୁ", whats_included: "କ'ଣ ଅନ୍ତର୍ଭୁକ୍ତ",
    payment_history: "ଦେୟ ଇତିହାସ", download_receipt: "ରସିଦ", start_date: "ଆରମ୍ଭ ତାରିଖ",
    expiry_date: "ସମାପ୍ତି ତାରିଖ", days_left: "ଦିନ ବାକି", status: "ସ୍ଥିତି",
    plan_active: "ସକ୍ରିୟ", plan_expired: "ସମାପ୍ତ", plan_none: "ସବସ୍କ୍ରାଇବ୍ ହୋଇନାହିଁ",
    subscriptions: "ସବସ୍କ୍ରିପସନ୍", payments: "ଦେୟ", settings: "ସେଟିଂସ୍",
    refer_earn: "ରେଫର୍ କରି ପାଆନ୍ତୁ", refer_headline: "୧୦୦ ଶିକ୍ଷକଙ୍କୁ ରେଫର୍ କରନ୍ତୁ → ଡବଲ୍ ପୁରସ୍କାର ପାଆନ୍ତୁ! 🎉",
    refer_sub: "କେବଳ ଆପଣଙ୍କ ଲିଙ୍କ ଶିକ୍ଷକ WhatsApp ଗ୍ରୁପ୍‌ରେ ସେୟାର୍ କରନ୍ତୁ।",
    reward1_title: "୧ ବର୍ଷ ମାଗଣା", reward1_desc: "₹99 ମୂଲ୍ୟ · ଅସୀମିତ ଗଣନା ଓ ସମସ୍ତ ରିପୋର୍ଟ",
    reward2_title: "୩ ମାସ ଅସୀମିତ ରିଚାର୍ଜ", reward2_desc: "ଆପଣଙ୍କ ନିଜ ନମ୍ବରରେ କଲ୍ + ଡାଟା",
    total_value_up_to: "ମୋଟ ମୂଲ୍ୟ", tnc_apply: "ସର୍ତ୍ତାବଳୀ ଲାଗୁ",
    claim_recharge: "ରିଚାର୍ଜ ଦାବି କରନ୍ତୁ", recharge_reward: "୩-ମାସ ରିଚାର୍ଜ ପୁରସ୍କାର",
    my_number: "ଆପଣଙ୍କ ପଞ୍ଜୀକୃତ ନମ୍ବର", operator: "ଅପରେଟର୍", circle: "ସର୍କଲ୍",
    confirm_own_number: "ଏହା ମୋର ନିଜ ସକ୍ରିୟ ପ୍ରିପେଡ୍ ନମ୍ବର", claim_now: "ଦାବି କରନ୍ତୁ",
    prepaid_only: "ରିଚାର୍ଜ କେବଳ ପ୍ରିପେଡ୍ ନମ୍ବର ପାଇଁ। ପୋଷ୍ଟପେଡ୍ ହେଲେ, ଆଡମିନ୍ ଅତିରିକ୍ତ ମାଗଣା ସବସ୍କ୍ରିପସନ୍ ମାସ ଦେଇପାରନ୍ତି।",
    st_claimed: "ଦାବି ହେଲା", st_verification: "ଯାଞ୍ଚ ଚାଲିଛି", st_approved: "ଅନୁମୋଦିତ",
    st_done: "ରିଚାର୍ଜ ସମାପ୍ତ", st_rejected: "ପ୍ରତ୍ୟାଖ୍ୟାନ",
    only_x_more_double: "ଆଉ — ମାଗଣା ବର୍ଷ + ମାଗଣା ରିଚାର୍ଜ ପାଇଁ!",
    qr_or_scan: "କିମ୍ବା UPI QR ସ୍କାନ୍ କରି ଦେୟ ଦିଅନ୍ତୁ (GPay, PhonePe, Paytm, BHIM)",
    qr_pay_title: "UPI QR ଦ୍ୱାରା ଦେୟ", qr_scan_pay: "ସ୍କାନ୍ କରି ଦିଅନ୍ତୁ", qr_pay_exact: "ଠିକ୍ ପରିମାଣ ଦିଅନ୍ତୁ",
    qr_download: "QR ଡାଉନଲୋଡ୍", qr_step1: "ଯେକୌଣସି UPI ଆପ୍ ଖୋଲନ୍ତୁ", qr_step2: "ଏହି QR ସ୍କାନ୍ କିମ୍ବା ଅପଲୋଡ୍ କରନ୍ତୁ",
    qr_step3: "₹99 ଦିଅନ୍ତୁ ଓ UTR / Transaction ID ଲେଖନ୍ତୁ",
    qr_warn: "ଠିକ୍ ପରିମାଣ ଦିଅନ୍ତୁ। ଭୁଲ୍ ପରିମାଣ ସକ୍ରିୟତାରେ ବିଳମ୍ବ କରିପାରେ।",
    qr_proof_title: "ଦେୟ ପ୍ରମାଣ ଦାଖଲ କରନ୍ତୁ", qr_utr: "UTR / UPI Transaction ID (12 ଅଙ୍କ)",
    qr_amount: "ଦିଆଯାଇଥିବା ପରିମାଣ", qr_datetime: "ଦେୟ ତାରିଖ ଓ ସମୟ", qr_app: "ବ୍ୟବହୃତ UPI ଆପ୍",
    qr_screenshot: "ଦେୟ ସ୍କ୍ରିନସଟ୍ (JPG/PNG, ସର୍ବାଧିକ 3 MB)", qr_submit: "ଯାଞ୍ଚ ପାଇଁ ଦାଖଲ କରନ୍ତୁ",
    qr_send_admin: "WhatsApp ରେ ଆଡମିନ୍‌ଙ୍କୁ ପ୍ରମାଣ ପଠାନ୍ତୁ",
    qr_attach_note: "ଦୟାକରି WhatsApp ରେ ମଧ୍ୟ ଆପଣଙ୍କ ଦେୟ ସ୍କ୍ରିନସଟ୍ ଯୋଡନ୍ତୁ।",
    qr_pending_status: "QR ଦେୟ ଯାଞ୍ଚ ଚାଲିଛି (ସାଧାରଣତଃ କିଛି ଘଣ୍ଟା ମଧ୍ୟରେ)",
    qr_resubmit: "ପୁନଃ ଦାଖଲ", qr_request_id: "ଅନୁରୋଧ ID",
    copy_code: "କୋଡ୍ କପି କରନ୍ତୁ", copied: "କପି ହେଲା", more_to_go: "ଆଉ ବାକି!",
    share_now: "ବର୍ତ୍ତମାନ ସେୟାର୍ କରନ୍ତୁ", how_it_works: "କିପରି କାମ କରେ", my_referrals: "ମୋ ରେଫରାଲ୍",
    download_poster: "ପୋଷ୍ଟର୍ ଡାଉନଲୋଡ୍", refer_terms: "ରେଫରାଲ୍ ପ୍ରୋଗ୍ରାମ ସର୍ତ୍ତାବଳୀ",
    all: "ସମସ୍ତ", valid: "ବୈଧ", pending: "ବିଚାରାଧୀନ",
    working_day: "କାର୍ଯ୍ୟ ଦିବସ", holiday: "ଛୁଟି", mdm_serving: "MDM ପରିବେଷଣ ଦିନ",
    dry_ration_day: "ଶୁଖିଲା ରାସନ ଦିନ", todays_meal: "ଆଜିର ଭୋଜନ", mark_holiday: "ଛୁଟି ଭାବେ ଚିହ୍ନଟ କରନ୍ତୁ",
    holiday_reason: "ଛୁଟିର କାରଣ", editing_saved: "ସେଭ୍ ଏଣ୍ଟ୍ରି ସମ୍ପାଦନା",
    students_dry: "ଶୁଖିଲା ରାସନ ପାଉଥିବା ଛାତ୍ର", payment_mode: "ଦେୟ ମାଧ୍ୟମ",
    bank_dbt: "ବ୍ୟାଙ୍କ ଖାତା (DBT)", cash_hand: "ନଗଦ", laddoo_day: "ଲଡ୍ଡୁ ଦିନ", egg_day: "ଅଣ୍ଡା ଦିନ",
    day_type_req: "ପ୍ରଥମେ ଦିନର ପ୍ରକାର ବାଛନ୍ତୁ।", future_preview: "ଭବିଷ୍ୟତ ତାରିଖ — କେବଳ ପ୍ରିଭ୍ୟୁ, ସେଭ୍ ହେବନାହିଁ।",
    download_pdf: "PDF ଡାଉନଲୋଡ୍", download_excel: "Excel ଡାଉନଲୋଡ୍", replace_saved: "ସେଭ୍ ଏଣ୍ଟ୍ରି ବଦଳାଇବେ?",
    govt_holiday: "ସରକାରୀ ଛୁଟି", not_for_entry: "ଏଣ୍ଟ୍ରି ପାଇଁ ନୁହେଁ",
    bulk_entry: "ବଲ୍କ ଏଣ୍ଟ୍ରି", bulk: "ବଲ୍କ", more: "ଅଧିକ", language: "ଭାଷା", suggestions: "ପରାମର୍ଶ",
    bulk_choose_period: "ଅବଧି ବାଛନ୍ତୁ", bulk_month_mode: "ମାସ", bulk_range_mode: "କଷ୍ଟମ୍ ପରିସର",
    bulk_from: "ଠାରୁ", bulk_to: "ପର୍ଯ୍ୟନ୍ତ", bulk_range_max: "ପରିସର ସର୍ବାଧିକ ୩୧ ଦିନ ହୋଇପାରିବ।",
    bulk_calc_preview: "ଗଣନା ଓ ପ୍ରିଭ୍ୟୁ", bulk_save_all: "ସବୁ ସେଭ୍ କରନ୍ତୁ", bulk_back_edit: "ସମ୍ପାଦନାକୁ ଫେରନ୍ତୁ",
    bulk_ready: "ପ୍ରସ୍ତୁତ", bulk_missing: "ବାକି", bulk_holidays: "ଛୁଟି",
    bulk_copy_prev: "ପୂର୍ବ ଦିନ କପି କରନ୍ତୁ", bulk_fill_working: "ସବୁ କାର୍ଯ୍ୟ ଦିନ ଭରନ୍ତୁ",
    bulk_use_enrolled: "ନାମଲେଖା ସଂଖ୍ୟା ବ୍ୟବହାର କରନ୍ତୁ", bulk_mark_sundays: "ସବୁ ରବିବାରକୁ ଛୁଟି ଚିହ୍ନଟ କରନ୍ତୁ",
    bulk_apply: "ପ୍ରୟୋଗ କରନ୍ତୁ", bulk_saved_chip: "ସେଭ୍ ହେଲା", bulk_will_update: "ଅପଡେଟ୍ ହେବ",
    bulk_speed_tools: "ଶୀଘ୍ର ଉପକରଣ", bulk_filter: "ଫିଲ୍ଟର୍",
    bulk_upgrade_title: "ବଲ୍କ ଏଣ୍ଟ୍ରି ସହ ୨ ମିନିଟ୍‌ରେ ପୁରା ମାସ ସେଭ୍ କରନ୍ତୁ — ₹99/ବର୍ଷ",
    bulk_download_template: "ଟେମ୍ପ୍ଲେଟ୍ ଡାଉନଲୋଡ୍", bulk_upload_excel: "ପୂରଣ Excel ଅପଲୋଡ୍",
    bulk_preview_title: "ପ୍ରିଭ୍ୟୁ ଓ ସେଭ୍", bulk_month_totals: "ମାସିକ ମୋଟ",
    bulk_mdm_days: "MDM ଦିନ", bulk_dry_days: "ଶୁଖିଲା ରାସନ ଦିନ",
    bulk_total_cooking: "ମୋଟ ରୋଷେଇ ଖର୍ଚ୍ଚ", bulk_dry_amount: "ଶୁଖିଲା ରାସନ ରାଶି",
    bulk_total_rice: "ମୋଟ ଚାଉଳ", bulk_fix: "ଠିକ୍ କରନ୍ତୁ", bulk_errors_top: "ପ୍ରଥମେ ଏଗୁଡ଼ିକ ଠିକ୍ କରନ୍ତୁ",
    bulk_saving: "ସେଭ୍ ହେଉଛି…", bulk_saved_result: "ଦିନ ସେଭ୍ ହେଲା", bulk_skipped_result: "ବାଦ୍ ଦିଆଗଲା",
    bulk_update_confirm: "ପୂର୍ବରୁ ସେଭ୍ ଦିନ ଅପଡେଟ୍ ହେବ। ଆଗକୁ ବଢ଼ିବେ?",
    bulk_update_btn: "ଅପଡେଟ୍", bulk_skip_btn: "ପରିବର୍ତ୍ତିତ ବାଦ୍",
    bulk_view_mdcf: "ମାସିକ (MDCF) ଦେଖନ୍ତୁ", bulk_demo_note: "ଏହା ଏକ ପ୍ରିଭ୍ୟୁ। ପୁରା ମାସ ଏକାଥରେ ସେଭ୍ କରିବାକୁ ସବସ୍କ୍ରାଇବ୍ କରନ୍ତୁ।",
    bulk_students: "ଶ୍ରେଣୀ ଅନୁସାରେ ଛାତ୍ର", status_dot: "ସ୍ଥିତି",
    preparing_receipt: "ପ୍ରସ୍ତୁତ ହେଉଛି…", share_receipt: "ରସିଦ ସେୟାର୍",
    msg_preview: "ମେସେଜ୍ ପ୍ରିଭ୍ୟୁ", share_whatsapp: "WhatsApp ରେ ସେୟାର୍ କରନ୍ତୁ",
    copy_message: "ମେସେଜ୍ କପି", copy_short: "ଛୋଟ ମେସେଜ୍ କପି", msg_copied: "ମେସେଜ୍ କପି ହେଲା!",
    unsaved_download_hint: "ଅସେଭ୍ ପରିବର୍ତ୍ତନ — ଆମେ ନୂଆ ତଥ୍ୟ ସେଭ୍ କରି ଡାଉନଲୋଡ୍ କରିବୁ",
    save_download_pdf: "ସେଭ୍ ଓ PDF", save_download_excel: "ସେଭ୍ ଓ Excel",
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("pm_lang") || "en");
  const toggle = useCallback(() => {
    setLang((l) => {
      const n = l === "en" ? "or" : "en";
      localStorage.setItem("pm_lang", n);
      return n;
    });
  }, []);
  const t = useCallback((key) => (STR[lang] && STR[lang][key]) || STR.en[key] || key, [lang]);
  return <LangContext.Provider value={{ lang, t, toggle, isOr: lang === "or" }}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
